import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private $isVisible = new Subject<boolean>();
  private indicators = 0;

  isVisibleSubj() {
    return this.$isVisible;
  }

  isVisible() {
    return this.indicators > 0;
  }

  showLoading() {
    this.indicators++;
    this.$isVisible.next(this.indicators > 0);
  }

  hideLoading() {
    this.indicators--;
    this.$isVisible.next(this.indicators > 0);
  }
}
